import { loadConfig } from "./auth0";

const APICONFIG = {
  APIBASEURL: process.env.APIBASEURL,
  GETPROFILE: process.env.GETPROFILE,
  SELECTIONSET: process.env.SELECTIONSET,
  GETPMEINDEX: process.env.GETPMEINDEX,
  GETPEERGROUPS: process.env.GETPEERGROUPS,
  GETPROFILES: process.env.GETPROFILES,
  GETLICENSES: process.env.GETLICENSES,
  GETPORTFOLIOS: process.env.GETPORTFOLIOS,
  GETINVESTORS: process.env.GETINVESTORS,
  GETMEASUREMENTDATES: process.env.GETMEASUREMENTDATES,
  GETCURRENCIES: process.env.GETCURRENCIES,
  GETINVESTMENTS: process.env.GETINVESTMENTS,
  GETPERCENTRANK: process.env.GETPERCENTRANK,
  GETUA: process.env.GETUA,
  GETPOOLEDBENCH: process.env.GETPOOLEDBENCH,
  GETPORTFOLIORANKING: process.env.GETPORTFOLIORANKING,
  GETPORTFOLIORANKINGUNIV: process.env.GETPORTFOLIORANKINGUNIV,
  GETFILTERFIELDS: process.env.GETFILTERFIELDS,
  GETFILTERVALUES: process.env.GETFILTERVALUES,
  GETATTRIBUTECONFIG: process.env.GETATTRIBUTECONFIG,
  GETTRANSACTIONFILTERSETS: process.env.GETTRANSACTIONFILTERSETS,
  GETCURRENCYHEDGE: process.env.GETCURRENCYHEDGE,
  GETCONFIG: process.env.GETCONFIG,
  GETBATCHCONFIG: process.env.GETBATCHCONFIG,
  GETCUSTOMFIELDMASTERDATA: process.env.GETCUSTOMFIELDMASTERDATA,
  GETALTERNATEBASECURRENCY: process.env.GETALTERNATEBASECURRENCY,
  GETQANALYSIS: process.env.GETQANALYSIS,
  GETPRECENTRANKCAPITALIZATION: process.env.GETPRECENTRANKCAPITALIZATION,
  GETPORTFOLIOBENCHMARKUNIV: process.env.GETPORTFOLIOBENCHMARKUNIV,
  GETPORTFOLIOANALYSIS: process.env.GETPORTFOLIOANALYSIS,
};

export const getApiConfig = () => {
  if (sessionStorage.getItem("isConfigLoaded") !== "true") {
    console.warn("Configuration not loaded. Loading now...");
    loadConfig();
  }

  return {
    ...APICONFIG,
    APIBASEURL: sessionStorage.getItem("APIBASEURL"),
  };
};
